import * as React from 'react';

import { ColorCircle, Container, Label, LabelAndColorContainer } from './tabSmall.styled';
import { TabSmallProps } from './tabSmall.types';

export const TabSmall: React.FC<TabSmallProps> = (props: TabSmallProps): JSX.Element => {
  const { className, tabSmallTheme, label, color, onClick }: TabSmallProps = props;

  return (
    <Container className={className} $theme={tabSmallTheme} onClick={onClick}>
      <LabelAndColorContainer>
        {color && <ColorCircle $color={color} />}
        <Label $theme={tabSmallTheme}>{label}</Label>
      </LabelAndColorContainer>
    </Container>
  );
};
